<template>
  <ul class="task-list">
    <slot />
  </ul>
</template>

<script>
import { ContainerMixin } from 'vue-slicksort';

export default {
  mixins: [ContainerMixin],
}
</script>
